import React, { useState, useEffect, useRef } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Pager,
} from '../../../components';

import CompaniesResult from './Result';
import CompaniesForm from './Form';
import useSearchApi from './useSearchApi';

import './style.scss';

const ParagraphParticipantsList = ({ match }) => {
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const { t } = useTranslation();
  const titleRef = useRef();
  const [results, query, currentYear, loading, downloadUrl, doSearch] = useSearchApi('companies', '', language);

  const [searchTerm, setSearchTerm] = useState(query);
  const [year, setYear] = useState(currentYear);


  // Scroll into view data is loaded.
  useEffect(() => {
    if (!loading && titleRef.current) {
      titleRef.current.scrollIntoView();
    }
  }, [loading, titleRef]);

  const items = results.get('results', Immutable.List());
  const resultItems = items.keySeq().map((key) => {
    const entity = items.get(key);

    return (
      <CompaniesResult
        key={key}
        title={entity.getIn(['title', 0, 'value'])}
        cocNumber={entity.getIn(['field_coc_number', 0, 'value'])}
        regulation={entity.getIn(['field_regulation', 0, 'value'])}
      />
    );
  });

  const currentPage = results.getIn(['pager', 'current_page'], 0);
  const resultsTotal = results.getIn(['pager', 'total_items'], null);
  const totalPages = results.getIn(['pager', 'total_pages'], 0);

  useEffect(() => {
    doSearch(searchTerm, year, 0);
  }, [searchTerm, year, doSearch]);


  return (
    <Container className="Search">
      <div className="row">
        <div className="col-12" ref={titleRef}>
          <CompaniesForm
            onSubmit={() => doSearch(searchTerm, year, 0)}
            value={searchTerm}
            setValue={setSearchTerm}
            year={year}
            setYear={setYear}
            downloadUrl={downloadUrl}
          />
          <div className="Search__results">
            {resultsTotal ? (
              <div>
                <div className="Search__results__header row">
                  <div className="CompaniesResult__header col-12 col-md-6">{t('search.companies.result_header_title')}</div>
                  <div className="CompaniesResult__coc  col-6 col-md-3">{t('search.companies.result_header_coc')}</div>
                  <div className="CompaniesResult__regulation col-6 col-md-3">{t('search.companies.result_header_regulation')}</div>
                </div>
                {resultItems}
              </div>
            ) : (
              <>
                {loading && (
                  <div className="Search__result__loading">
                    {t('search.loading')}
                  </div>
                )}
                {!loading && (
                  <div className="Search__result__empty">
                    <div>{t('search.result_empty')}</div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="Search__pager">
            <Pager
              currentPage={currentPage}
              totalPages={totalPages}
              setCurrentPage={(page) => { doSearch(searchTerm, year, page); }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};


export default ParagraphParticipantsList;
